import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {ConfigService} from './config.service';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {NamespaceTablesInterfaceAPI} from '../..';
import {TableFieldsInterfaceAPI} from '../..';

@Injectable({
  providedIn: 'root'
})
export class HandleNamespaceSelectionsService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(ConfigService) private config: any, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'SDSETUP').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getAllTables(namespace: string): Observable<NamespaceTablesInterfaceAPI> {
    console.log('Namespace: ' + namespace);
    const headers = this.headers;
    return this.httpClient.get<NamespaceTablesInterfaceAPI>(`${this.URL}/hns/getalltables/${namespace}`, {headers}).pipe(
        catchError(this.handleError));
  }

  getAllFields(table: string): Observable<TableFieldsInterfaceAPI> {
    console.log('Table: ' + table);
    const headers = this.headers;
    return this.httpClient.get<TableFieldsInterfaceAPI>(`${this.URL}/hns/getallfields/${table}`, {headers}).pipe(
        catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }
}
